@if (model) {
    <form [formGroup]="model">
        <app-reactive-form-header
            [tourAnchor]="getTourAnchorId('farmerTour.formHeader')"
            [form]="form"
            [model]="model"
            [isLoading]="isLoading"
            [headerButtons]="getHeaderButtons()"
            (headerButtonClick)="executeConfiguredButton($event)"
            (imageChange)="updateImageModel($event.imageName, $event.fieldName)">
        </app-reactive-form-header>

        @if (isDevelopmentMode) {
            <div class="d-flex flex-wrap justify-content-end gap-2 my-2">
                <button
                    type="button"
                    class="btn btn-sm btn-outline-secondary text-nowrap"
                    [tourAnchor]="getTourAnchorId('farmerTour.fieldHelpToggle')"
                    [attr.aria-pressed]="showFieldHelpButtons"
                    (click)="toggleFieldHelpButtons()">
                    <i class="pi pi-info-circle" aria-hidden="true"></i>
                    {{ showFieldHelpButtons ? 'Ocultar ayuda de campos' : 'Mostrar ayuda de campos' }}
                </button>

                <div [tourAnchor]="getTourAnchorId('farmerTour.formGuideButton')">
                    <button
                        type="button"
                        class="btn btn-sm btn-info text-white text-nowrap fw-bold farmer-module-info-button"
                        pTooltip="Guía del formulario"
                        tooltipPosition="bottom"
                        (click)="startCurrentFormTour()">
                        <i class="pi pi-info-circle" aria-hidden="true"></i>
                        <span> Guía del formulario</span>
                    </button>
                </div>
            </div>
        }

        <section *ngIf="areTipsEnabled" class="farmer-form-guidance-summary" aria-label="Consejos para rellenar el formulario">
            <strong>Antes de guardar:</strong>
            <ul class="farmer-form-guidance-list">
                @for (tip of getFormGuidanceTips(); track trackByGuidanceTip($index, tip)) {
                    <li>{{ tip }}</li>
                }
            </ul>
        </section>

        <div class="row flex-wrap">
            <div class="col-12" [tourAnchor]="getTourAnchorId('farmerTour.formSections')">
                <app-reactive-form-sections
                    [form]="form"
                    [model]="model"
                    [originalModel]="originalModel"
                    [filterInputParcelas]="filterInputParcelas"
                    [externalDropdownsReady]="areExternalDropdownsReady()"
                    [fieldStates]="fieldStates"
                    [renderVersion]="fieldRenderVersion"
                    [undoEnabled]="undoEnabled"
                    [debug]="debug"
                    [showFieldHelpButtons]="showFieldHelpButtons"
                    [tourAnchorsEnabled]="tourAnchorsEnabled"
                    (retryDropdown)="refreshDeclarativeDropdown($event)"
                    (lazyDropdownRequested)="loadLazyDeclarativeDropdown($event)"
                    (lazyDropdownFilterRequested)="requestLazyDropdownFilter($event)">
                </app-reactive-form-sections>
            </div>

            @if (hasMainTableData()) {
                <div class="col-12 d-flex justify-content-center mt-3">
                    <app-reactive-form-table [table]="form.table!"></app-reactive-form-table>
                </div>
            }

            <div class="col-12">
                <app-reactive-form-signature
                    [form]="form"
                    [model]="model"
                    [serverUrl]="serverUrl"
                    (signatureFile)="getSignature($event)"
                    (signatureTempImage)="updateFirma($event)">
                </app-reactive-form-signature>
            </div>

            <ng-content select="[slot=before-actions]"></ng-content>

            <div class="col-12 d-flex flex-wrap align-items-center justify-content-center" [tourAnchor]="getTourAnchorId('farmerTour.formActions')">
                <app-reactive-form-actions
                    [form]="form"
                    [model]="model"
                    [recordHasAssociatedData]="recordHasAssociatedData"
                    [showActionsButtons]="showActionsButtons"
                    [request]="request"
                    [getRequest]="getRequest"
                    [requestAdapter]="requestAdapter"
                    [getRequestAdapter]="getRequestAdapter"
                    [recordId]="resolvedRecordId"
                    [resolveDropdownRawValue]="resolveDropdownRawValueForSubmit"
                    [resolveDropdownBackendValue]="resolveDropdownBackendValueForSubmit"
                    (goBack)="returnToMainView()"
                    (closeDialog)="closeDialog()"
                    (afterSend)="executePostSubmissionLogic($event)">
                </app-reactive-form-actions>

                <ng-content select="[slot=extra-buttons]"></ng-content>
            </div>
        </div>
    </form>
}
